// extracted by mini-css-extract-plugin
export default {"key":"MapG_key__67iu-","userData":"MapG_userData__X9d1B","lg":"MapG_lg__zYBSB"};